import { Component, OnInit } from '@angular/core';
import { InputElement } from '../../input-element';

@Component({
    selector: 'chassis-core-elements-input-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss']
})
export class PasswordComponent extends InputElement implements OnInit {
    ngOnInit() {
        // console.log('Password input component: ', this.data);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/elements/input/password/password.component.ts